import "./App.scss";
import WOW from "wowjs";
import Footer from "./components/Footer";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Tooltip } from "./components/Tooltip";
import LandingWedding from "./pages/LandingWedding";
import LandingFashion from "./pages/LandingFashion";
import LandingMain from "./pages/LandingMain";

// Layout component to avoid repetition
const Layout = ({ children, handleNavClick }) => {
  const [scrollTopVisible, setScrollTopVisible] = useState(false);
  
  useEffect(() => {
    const checkScrollTop = () => {
      if (
        document.body.scrollTop > 400 ||
        document.documentElement.scrollTop > 400
      ) {
        setScrollTopVisible(true);
      } else {
        setScrollTopVisible(false);
      }
    };
    
    // Add event listener
    window.addEventListener("scroll", checkScrollTop);
    
    // Initial check
    checkScrollTop();
    
    // Cleanup event listener on component unmount
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, []);
  
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  
  return (
    <div style={{ position: "relative" }}>
      <div id="main-wrapper">
        {children}
        <Footer handleNavClick={handleNavClick} />
      </div>

      {/* back to top */}
      <Tooltip text="Back to Top" placement="left">
        <span
          id="back-to-top"
          className="rounded-circle"
          style={{ display: scrollTopVisible ? "inline" : "none" }}
          onClick={scrollToTop}
        >
          <i className="fas fa-arrow-up"></i>
        </span>
      </Tooltip>
    </div>
  );
};

function App() {
  const handleNavClick = (section) => {
    document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    // Initialize WOW.js once when the component mounts
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();
    
    // No cleanup needed for WOW.js
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/">
          <Route index element={
            <Layout handleNavClick={handleNavClick}>
              <LandingMain />
            </Layout>
          } />
          
          <Route path="wedding" element={
            <Layout handleNavClick={handleNavClick}>
              <LandingWedding />
            </Layout>
          } />
          
          <Route path="fashion" element={
            <Layout handleNavClick={handleNavClick}>
              <LandingFashion />
            </Layout>
          } />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
